module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.computedClasses,
    attrs: {
      "id": "app"
    }
  }, [_c('q-layout', [_c('div', {
    staticClass: "header-container"
  }, [_c('navigation', {
    attrs: {
      "id": "desktop-nav"
    }
  }), _vm._v(" "), _c('mobile-navigation', {
    attrs: {
      "id": "mobile-nav"
    }
  })], 1), _vm._v(" "), (!_vm.isPageContent && !_vm.isShowingOnboarding) ? _c('secondary-header', {
    class: {
      'hidden': _vm.isRetrieving
    }
  }) : _vm._e(), _vm._v(" "), (this.isRetrieving) ? _c('div', {
    staticClass: "spinner-wrapper"
  }, [_c('loading')], 1) : _vm._e(), _vm._v(" "), _c('div', {
    class: {
      'main-content': true, 'main-content--lead': _vm.isPageLead, 'main-content--projects': _vm.isPageProjects, 'main-content--projects': _vm.isPageProjectNew, 'empty-state-projects': _vm.emptyStateProjects, 'empty-state-leads': _vm.emptyStateLeads, 'main-content--manager': _vm.isPageContent, 'hidden': _vm.isRetrieving
    }
  }, [_c('q-page-container', [_c('router-view', {
    key: _vm.$route.fullPath,
    staticClass: "router-view",
    on: {
      "logout": function($event) {
        return _vm.$emit('logout')
      }
    }
  })], 1)], 1), _vm._v(" "), _c('app-footer')], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1abbe534","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layouts/Layout.vue
// module id = 1828
// module chunks = 0